import React, { Component } from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'

import { PrivateRoute, AdminRoute } from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'
import Campaigns from 'Containers/Campaigns'
import { CampaignRouter } from './CampaignRouter'
import CreateEditCampaign from '../../Containers/Campaigns/CreateEditCampaign'

class CampaignsRouter extends Component {
  render() {
    return (
      <Switch>
        <Route path={`${this.props.match.url}${PATHS.campaigns.create}`}>
          <AdminRoute>
            <CreateEditCampaign {...this.props} />
          </AdminRoute>
        </Route>
        <Route
          path={`${this.props.match.url}${PATHS.campaigns.campaign}${
            PATHS.campaign.edit
          }`}
        >
          <AdminRoute>
            <CreateEditCampaign {...this.props} editMode />
          </AdminRoute>
        </Route>
        <Route path={`${this.props.match.url}${PATHS.campaigns.campaign}`}>
          <PrivateRoute>
            <CampaignRouter {...this.props} />
          </PrivateRoute>
        </Route>
        <Route path={this.props.match.url}>
          <PrivateRoute>
            <Campaigns {...this.props} />
          </PrivateRoute>
        </Route>
      </Switch>
    )
  }
}

export default withRouter(CampaignsRouter)



// WEBPACK FOOTER //
// ./src/Config/Routing/CampaignsRouter.js